/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteExternalSendSafelyRecipientsRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {DeleteExternalSendSafelyRecipientsResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const deleteExternalSendSafelyRecipients = (request: DeleteExternalSendSafelyRecipientsRequest, options?: CashRequestOptions) => post<DeleteExternalSendSafelyRecipientsRequest, DeleteExternalSendSafelyRecipientsResponse>("/2.0/cash/delete-external-send-safely-recipients", request, {...options, rejectOnError: true })